import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import CustomButton from "../../../ui/custom-button";
import { PulseLoader } from "react-spinners";
import {
  AddEventApi,
  fetchCameragrouplistingApi,
  getEventDataById,
  updateEventApi,
  UseCaseeventListApi,

  // UseCaseListingApi,
} from "../../../api/api";
import { toast } from "react-toastify";

function AddEvent() {
  const dispatch = useDispatch();
  const [cameraGroups, setCameraGroups] = useState([]);
  //console.log("cameraGroups", cameraGroups);
  const [useCase, setUseCase] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    name: "",
    use_case: "",
    event: "",
  });

  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    if (data) {
      fetchdata();
    }
  }, []);

  const fetchdata = async () => {
    try {
      const detail = await getEventDataById(data);
      if (detail?.data?.status === true) {
        const fetched = detail?.data?.data;
        //console.log("Fetched detail", fetched);
        setInputData({
          name: fetched?.event_name || "",
          use_case: fetched?.usecase_id || "",
          event: fetched?.camera_grp_id || "",
        });
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi("", user_id, organization_id);
      //console.log("data", data);
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const fetchCameraGroup = async () => {
    try {
      const data = await fetchCameragrouplistingApi(
        "",
        user_id,
        organization_id
      );
      if (data?.data?.status === true) {
        setCameraGroups(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
    fetchCameraGroup();
  }, []);
  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      event_name: inputData.name,
      usecase_id: inputData.use_case,
      camera_grp_id: inputData.event,
      user_id,
      organization_id,
    };

    //console.log("Submitting payload:", payload);

    try {
      let response;
      if (data) {
        response = await updateEventApi(payload, data);
      } else {
        response = await AddEventApi(payload);
      }

      if (response) {
        toast(
          data ? "Event updated successfully" : "Event created successfully"
        );
        handleClose();
      }
    } catch (error) {
      console.error("Error submitting event:", error);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">{data ? "Edit" : "Add"} Event</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12 mb-3">
            <label className="form-label">Event Name</label>
            <CustomInput
              name="name"
              placeholder="Enter Event Name"
              value={inputData.name}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">UseCase</label>
            <select
              name="use_case"
              className="form-select"
              value={inputData.use_case}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {useCase &&
                useCase?.map((ele) => (
                  <option value={ele?._id}>{ele?.usecase_name}</option>
                ))}
            </select>
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Camera Group</label>
            <select
              name="event"
              className="form-select"
              value={inputData.event}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {cameraGroups &&
                cameraGroups?.map((ele) => (
                  <option value={ele?._id}>{ele?.camera_grp_name}</option>
                ))}
            </select>
          </div>

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            {loading ? (
              <CustomButton type="submit" className="btnSubmit px-4 py-2">
                <PulseLoader color="#fff" size={8} />
              </CustomButton>
            ) : (
              <button className="btnSubmit px-4 py-2" type="submit">
                {data ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddEvent;
